export default __webpack_public_path__ + "static/media/PRESTIGIO-ONYX_WHITE-LUCIDO_120X278_02_265.a365e695.jpg";